import { InvestigationsRoutePath } from "#src/routes/investigations";
import { RoutePath } from "#src/utils/route";

/**
 * Legacy `/investigations/new` path. PageConfigs redirects this to
 * {@link InvestigationsRoutePath}.
 */
export const NewInvestigationRoutePath = InvestigationsRoutePath.concat(
  new RoutePath({
    path: "/new",
    title: "New Investigation",
  })
);
